import React from 'react';
import styled from 'styled-components';
import { COLORS, SHADOWS } from '../constants/styles';

const SwitchToggleWrapper = styled.div`
    align-tems: center;
    background-color: ${(props: { on?: boolean }) =>
        props.on ? COLORS.rakutenRed : COLORS.lightGrey};
    color: ${(props: { on?: boolean }) => (props.on ? COLORS.white : COLORS.grey)};
    border-radius: 100px;
    cursor: ${(props: { on?: boolean; disabled?: boolean }) =>
        props.disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    font-size: 0.875rem;
    opacity: ${(props: { on?: boolean; disabled?: boolean }) => (props.disabled ? '0.4' : '1')};
    padding: 10px 30px;
    position: relative;

    &:focus {
        outline: none;
    }
    width: 20px;
    height: 30px;
`;

const SwitchToggleBtnDot = styled.div`
    background: ${COLORS.white};
    border-radius: 50%;
    bottom: 0;
    box-shadow: ${SHADOWS.level30};
    height: 25px;
    margin: auto;
    position: absolute;
    top: 0;
    transition: right 0.3s;
    right: ${(props: { on?: boolean }) => (props.on ? '5px' : 'calc(100% - 30px)')};
    width: 25px;
`;

interface ISwitchToggleButtonProps {
    value: boolean;
    disabled?: boolean;
    onSwitch: (value: boolean) => any;
}

interface ISwitchToggleButtonState {
    on: boolean;
}

class SwitchToggleButton extends React.Component<
    ISwitchToggleButtonProps,
    ISwitchToggleButtonState
> {
    constructor(props: ISwitchToggleButtonProps) {
        super(props);
    }

    public render() {
        const { disabled, onSwitch, value } = this.props;
        return (
            <SwitchToggleWrapper
                disabled={disabled}
                role="switch-toggle-button"
                aria-checked={value}
                aria-disabled={disabled}
                on={value}
                onClick={() => {
                    if (!disabled) {
                        onSwitch(value);
                    }
                }}
            >
                <SwitchToggleBtnDot on={value} />
            </SwitchToggleWrapper>
        );
    }
}

export default SwitchToggleButton;
